import { Pill } from "@phosphor-icons/react"
import { joinStrings } from "@/lib/joinString"
import { RequestedMedicationsFragment$data } from "@/modules/patients/services/__generated__/RequestedMedicationsFragment.graphql"

export type RequestedMedication = NonNullable<RequestedMedicationsFragment$data["requestedMedications"]>[number]

interface RequestedMedicationItemProps {
  requestedMedication: RequestedMedication
  isMedicationDetailLoading: boolean
  onSelectRequestedMedication: (requestedMedication: RequestedMedication) => void
}

export const RequestedMedicationItem = ({
  requestedMedication,
  isMedicationDetailLoading,
  onSelectRequestedMedication,
}: RequestedMedicationItemProps) => {
  const { name, mainSubstance, packageSize } = requestedMedication

  const nameAndMainSubstance = joinStrings([name, mainSubstance])

  return (
    <button
      type="button"
      data-testid="requested-medication-item"
      className="hover:bg-surface-hovered active:bg-surface-pressed flex min-h-12 w-full cursor-pointer items-center gap-2 overflow-hidden rounded-md px-2 py-1.5 text-left transition-all duration-300"
      disabled={isMedicationDetailLoading}
      onClick={() => onSelectRequestedMedication(requestedMedication)}>
      <Pill className="text-on-surface-subdued h-5 w-5 shrink-0" />
      <div className="overflow-hidden">
        <p className="text-on-surface truncate text-sm leading-5 whitespace-nowrap" title={nameAndMainSubstance}>
          {nameAndMainSubstance}
        </p>
        {packageSize && (
          <p className="text-on-surface-subdued truncate text-xs leading-4 tracking-[0.25px]">{packageSize}</p>
        )}
      </div>
    </button>
  )
}
